import React, { useState } from "react";
import CapabilityHierarchyBuilder from "./CapabilityHierarchyBuilder";
import {
  TAXONOMY_HIERARCHY_CONFIGS,
  getTaxonomyHierarchyConfig,
} from "../utils/taxonomyHierarchyConfigs";

/**
 * Unified Admin Taxonomies screen: switch between capability, process,
 * organisation, objective, and initiative hierarchies.
 */
const TaxonomiesHierarchyPanel = () => {
  const [activeId, setActiveId] = useState(TAXONOMY_HIERARCHY_CONFIGS[0].id);
  const config = getTaxonomyHierarchyConfig(activeId);

  return (
    <div className="flex flex-col min-h-0">
      <div className="px-4 pt-4 pb-3 border-b border-slate-200 bg-slate-50/80 space-y-3">
        <div>
          <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-500 mb-1.5">
            Hierarchy type
          </p>
          <div
            className="flex flex-wrap gap-1.5"
            role="tablist"
            aria-label="Taxonomy hierarchy type"
          >
            {TAXONOMY_HIERARCHY_CONFIGS.map((item) => {
              const isActive = item.id === activeId;
              return (
                <button
                  key={item.id}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setActiveId(item.id)}
                  className={
                    isActive
                      ? "px-3 py-1.5 rounded-md text-sm font-semibold border border-red-500 bg-red-100 text-red-900 shadow-sm ring-1 ring-red-200"
                      : "px-3 py-1.5 rounded-md text-sm border border-slate-200 bg-white text-slate-600 hover:border-red-200 hover:bg-red-50/50"
                  }
                >
                  {item.navLabel}
                </button>
              );
            })}
          </div>
        </div>
        <p className="text-sm text-slate-600 leading-relaxed max-w-3xl">
          {config.shortDesc} Create, nest, reparent, edit, delete, and import
          from Excel—same workflow for every type.
        </p>
      </div>

      <CapabilityHierarchyBuilder
        key={config.entityType}
        config={config}
        embedded
        hideChromeTitle
      />
    </div>
  );
};

export default TaxonomiesHierarchyPanel;
